"use strict";
var Observable_1 = require('../../Observable');
var min_1 = require('../../operator/min');
Observable_1.Observable.prototype.min = min_1.min;
//# sourceMappingURL=min.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/rxjs/add/operator/min.js
// module id = ../../../../rxjs/add/operator/min.js
// module chunks = 4